import { httpCollection } from "us.helper/http/collection";

export default {
  saveAuthorizedInformation: (params: any): Promise<any> => {
    return new Promise<{}>(async (resolve, reject) => {
      try {
        const { data, status } = await httpCollection.post(
          "entityservice",
          "authorizedInformation",
          params.payload
        );

        resolve({ data, status });
      } catch (error) {
        reject(error);
      }
    });
  },
};
